import { css } from 'styled-components';
import {
  getTypography, getSpacing, SpacingName, TypographyName, ThemedFunctor,
} from '@doveit/bricks';

export const base: ThemedFunctor = ({
  theme,
  onClick,
}) => css`
  display: flex;
  ${getSpacing.padding(theme, [SpacingName.SMALLEST, 0, SpacingName.SMALLEST, SpacingName.SMALLEST])}
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);

  ${onClick && `
    cursor: pointer;
  `}
`;

export const picture: ThemedFunctor = ({
  theme,
}) => css`
  width: 5.25rem;
  height: 5.25rem;
  flex-shrink: 0;
  background-color: ${theme.palettes.neutrals.lighter};
  overflow: hidden;
`;

export const info: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.padding(theme, [SpacingName.SMALLEST, SpacingName.SMALL])}
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const link: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.SMALL)}
`;
